import { useQuery } from '@tanstack/react-query';
import { getUserAccountDetails } from '../api/userAccount/getUserAccountDetails';

export const useGetUserAccountDetails = () => {
  const { isLoading, isFetching, data, isError, isSuccess } = useQuery({
    queryKey: ['user-account'],
    queryFn: getUserAccountDetails,
  });

  return {
    initializing: isLoading || isFetching || isError,
    userAccountDetails: data,
    isSuccess: isSuccess,
  };
};
